import { render } from "./loaderApp.vue?vue&type=template&id=47096b0c&scoped=true"
import script from "./loaderApp.vue?vue&type=script&lang=js"
export * from "./loaderApp.vue?vue&type=script&lang=js"

import "./loaderApp.vue?vue&type=style&index=0&id=47096b0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47096b0c"

export default script